import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Получите <Highlighted>лучшее предложение</Highlighted> по займу на любые бизнес-цели',
  benefits: {
    sum: {
      label: 'Сумма займа',
      value: 'до 200 млн. ₽',
    },
    speed: {
      label: 'Скорость выдачи',
      value: 'до 5 рабочих дней',
    },
    returned: {
      label: 'Порядок возврата',
      value: 'без ежемесячных платежей',
    },
  },
  actions: {
    sendOrder: 'Подать заявку',
    more: 'Подробнее',
  },
  agreement:
    'Нажатие на кнопку "Подать заявку" подтверждает ваше <LinkToAgreement>согласие на передачу данных</LinkToAgreement>, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в ООО МКК «Поле Инвест»',
  hint: {
    forAgrariansOnly: 'Доступно только для аграриев',
  },
} satisfies TMessages
